namespace Matrix.Workflow {
    export namespace WorkflowInstanceService {
        export const baseUrl = 'Workflow/WorkflowInstance';

        export declare function Create(request: Serenity.SaveRequest<WorkflowInstanceRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<WorkflowInstanceRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<WorkflowInstanceRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function RetrieveQueue(request: WorkflowQueueRetrieveRequest, onSuccess?: (response: WorkflowQueueRetrieveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: WorkflowInstanceListRequest, onSuccess?: (response: Serenity.ListResponse<WorkflowInstanceRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Workflow/WorkflowInstance/Create",
            Update = "Workflow/WorkflowInstance/Update",
            Delete = "Workflow/WorkflowInstance/Delete",
            Retrieve = "Workflow/WorkflowInstance/Retrieve",
            RetrieveQueue = "Workflow/WorkflowInstance/RetrieveQueue",
            List = "Workflow/WorkflowInstance/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'RetrieveQueue', 
            'List'
        ].forEach(x => {
            (<any>WorkflowInstanceService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
